import {
    NOTIFICATION_ADD_ITEM,
    NOTIFICATION_RESET_ITEM,
    NOTIFICATION_ADD_ITEM_SUCCESS,
    NOTIFICATION_ADD_ITEM_ERROR,
    NOTIFICATION_FETCH_ITEM,
    NOTIFICATION_FETCH_ITEM_SUCCESS,
    NOTIFICATION_FETCH_ITEM_ERROR,
    NOTIFICATION_DELETE_ITEM,
    NOTIFICATION_DELETE_ITEM_SUCCESS,
    NOTIFICATION_DELETE_ITEM_ERROR,
    NOTIFICATION_SAVE_ITEM,
    NOTIFICATION_SAVE_ITEM_SUCCESS,
    NOTIFICATION_SAVE_ITEM_ERROR,
} from './actions_def';

import moment from 'moment'
const INIT_STATE = {
    notifications: null,
    errors: [],
    isLoading: false,
    isLoaded: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case NOTIFICATION_FETCH_ITEM:
            return { ...state, isLoading: false };

        case NOTIFICATION_FETCH_ITEM_SUCCESS:
            return {
                ...state,
                isLoading: true,
                allNotificationItems: action.payload,
                notificationItems: action.payload,
            };
        case NOTIFICATION_RESET_ITEM:
            return {
                INIT_STATE
            };
        case NOTIFICATION_FETCH_ITEM_ERROR:
            return { ...state, isLoading: true, error: action.payload };

        case NOTIFICATION_ADD_ITEM:
            return { ...state, saving: true };

        case NOTIFICATION_ADD_ITEM_SUCCESS:
            // console.log("Success", [...state.allNotificationItems, {
            //   id: action.payload.instance.rfc_id,
            //   title: action.payload.instance.rfc_title,
            //   date: moment(action.payload.instance.date_created).format("Do MMM YYYY"),
            //   change_date: moment(action.payload.instance.date_modified).format("Do MMM YYYY (hh:mm)"),
            //   end_date: moment(action.payload.instance.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
            //   status: action.payload.instance.rfc_status,
            //   statusColor: 'primary'
            // }])

            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                errors: [],
                notifications: action.payload.instance,
            };

        case NOTIFICATION_ADD_ITEM_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                errors: action.payload.errors && action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        case NOTIFICATION_DELETE_ITEM:
            return { ...state, saving: true };

        case NOTIFICATION_DELETE_ITEM_SUCCESS:
            console.log("Success", state.allNotificationItems.filter(item => item && item.id !== action.payload.rfc_id))

            return {
                ...state,
                isLoading: true,
                saving: false,
                saved: true,
                errors: [],

                allNotificationItems: state.allNotificationItems.filter(item => item && item.id !== action.payload.rfc_id),
                notificationItems: state.notificationItems.filter(item => item && item.id !== action.payload.rfc_id),
            };

        case NOTIFICATION_DELETE_ITEM_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: false,
                saving: false,
                saved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };


        case NOTIFICATION_SAVE_ITEM_SUCCESS:
            // console.log("Success", [...state.allNotificationItems, {
            //   id: action.payload.instance.rfc_id,
            //   title: action.payload.instance.rfc_title,
            //   date: moment(action.payload.instance.date_created).format("Do MMM YYYY"),
            //   change_date: moment(action.payload.instance.date_modified).format("Do MMM YYYY (hh:mm)"),
            //   end_date: moment(action.payload.instance.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
            //   status: action.payload.instance.rfc_status,
            //   statusColor: 'primary'
            // }])

            return {
                ...state,
                isLoading: true,
                saving: false,
                errors: [],
                allNotificationItems: [...state.allNotificationItems, {
                    id: action.payload.instance.rfc_id,
                    title: action.payload.instance.rfc_title,
                    date: moment(action.payload.instance.date_created).format("Do MMM YYYY"),
                    change_date: moment(action.payload.instance.date_modified).format("Do MMM YYYY (hh:mm)"),
                    end_date: moment(action.payload.instance.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                    status: action.payload.instance.rfc_status,
                    statusColor: 'primary'
                }],
                notificationItems: [...state.notificationItems,
                {
                    id: action.payload.instance.rfc_id,
                    title: action.payload.instance.rfc_title,
                    date: moment(action.payload.instance.date_created).format("Do MMM YYYY"),
                    change_date: moment(action.payload.instance.date_modified).format("Do MMM YYYY (hh:mm)"),
                    end_date: moment(action.payload.instance.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                    status: action.payload.instance.rfc_status,
                    statusColor: 'primary'
                }],
            };

        case NOTIFICATION_SAVE_ITEM_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: true,
                saving: false,
                errors: action.payload.errors && action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        case NOTIFICATION_SAVE_ITEM:
            return { ...state, saving: true };

        default:
            return { ...state };
    }
};
